<ng-container *transloco="let t">
    <a
        *tuiLet="
            (shop.options.turn_on_the_store_link_feature === false &&
                (!shop.options.turn_on_the_store_link_time ||
                    (shop.options.turn_on_the_store_link_time | dfnsParseIso | dfnsIsFuture))) ||
            (shop | openTimeToDay | async) === null as isDisable
        "
        class="group w-full h-full bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-2xl cursor-pointer flex lg:flex-col items-center lg:items-stretch text-gray-900 hover:text-gray-900"
        [routerLink]="['/', RouterUtil.Cog.Shops, shop.id]"
        [class.opacity-50]="isDisable"
        [class.disabled]="isDisable"
    >
        <div
            class="rounded-lg w-28 h-28 p-2 text-center items-center aspect-square lg:w-full lg:h-56 lg:p-0 lg:aspect-video bg-white lg:bg-gray-100 grid grid-cols-1 justify-items-center overflow-hidden"
        >
            <img
                *ngIf="shop.banners.length"
                class="w-full h-full object-cover rounded-lg"
                [ngSrc]="shop.banners[0]"
                [width]="300"
                [height]="224"
                alt=""
            />

            <tui-marker-icon *ngIf="!shop.banners.length" src="svg::shopping-bag"></tui-marker-icon>
        </div>
        <div class="flex-auto flex flex-col pb-1">
            <div class="px-2 py-2">
                <div class="font-bold text-xl mb-2">{{ shop.name }}</div>
                <p class="text-gray-500 text-base line-clamp-1 lg:line-clamp-2">
                    {{ shop.address }}
                </p>
            </div>

            <div class="flex-auto"></div>

            <div class="px-2 pt-1 pb-0.5 flex items-baseline justify-between">
                <button tuiButton size="s" appearance="none" icon="svg::map-pin" style="--tui-padding: 0">
                    {{ shop.location?.distance | convertMeters }}
                </button>

                <button
                    tuiButton
                    size="s"
                    appearance="none"
                    style="--tui-padding: 0"
                    *tuiLet="shop | openTimeToDay | async as openTime"
                >
                    {{ openTime === null ? t('closed') : openTime }}
                </button>
            </div>

            <div class="px-2 pt-1 pb-0.5 hidden lg:block">
                <button tuiButton class="w-full" size="m" appearance="primary" [disabled]="isDisable">
                    <span *ngIf="!isDisable">{{ t('ordering') }}</span>
                    <span
                        *ngIf="
                            isDisable &&
                            !shop.options.turn_on_the_store_link_time &&
                            (shop | openTimeToDay | async) !== null
                        "
                    >
                        {{ t('temporarily_suspending_orders') }}
                    </span>
                    <span *ngIf="isDisable && shop.options.turn_on_the_store_link_time">
                        <ng-container
                            *tuiLet="shop.options.turn_on_the_store_link_time! | dfnsParseIso as suspendingOrdersTo"
                        >
                            {{
                                t('temporarily_suspending_orders_to') +
                                    ' - ' +
                                    (suspendingOrdersTo
                                        | dfnsFormat
                                            : ((suspendingOrdersTo | dfnsIsToday) ? 'HH:mm' : 'HH:mm dd/MM/yyyy'))
                            }}
                        </ng-container>
                    </span>
                    <span *ngIf="isDisable && (shop | openTimeToDay | async) === null">
                        {{ t('closed') }}
                    </span>
                </button>
            </div>
        </div>
    </a>
</ng-container>
